import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {ReferralLinkConfigServiceTypes} from './constants';
import {ReferralLinkConfigEpicsBuilder} from './epics';
import {ReferralLinkConfigService} from './service';

export class ReferralLinkConfigContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(ReferralLinkConfigServiceTypes.service).to(ReferralLinkConfigService);
        this._container.bind(ReferralLinkConfigServiceTypes.epicsBuilder).to(ReferralLinkConfigEpicsBuilder);
    }
}
